/* eslint-disable no-unused-vars */
import axios from "@/helpers/axios";

/*
data: [
    {word: <ID>,
     yes_count: <INT>,
     no_count: <INT>,
    }
]
cards: [
    {
        front_word: {id:<ID>, word:<STRING>, },
    }
]
*/
function _computeQuizResultData(data, cards) {
  const result = {};
  if (Object.keys(data).length === 0) {
    return { learned_count: 0 };
  }
  cards.forEach(c => {
    const wordStat = data.find(item => item.word === c.front_word.id);
    if (wordStat) {
      result[c.front_word.word] = {
        yes: wordStat.yes_count,
        no: wordStat.no_count
      };
    } else {
      result[c.front_word.word] = {
        yes: 0,
        no: 0
      };
    }
  });

  let learned_count = 0;
  data.forEach(wordStat => {
    if (wordStat.yes_count && wordStat.yes_count > 0) {
      learned_count++;
    }
  });

  const tmp = {
    counts: result,
    learnedWordsPercentage: Math.round((learned_count / cards.length) * 100.0)
  };
  return tmp;
}
function _computeWordviewData(data, cards) {
  if (Object.keys(data).length === 0) {
    return {};
  }
  const result = {};
  cards.forEach(c => {
    const stats = data.seen_cards.find(view => {
      return view.card === c.id;
    });
    result[c.front_word.word] = stats ? stats.seen_count : 0;
  });
  return result;
}

export default {
  namespaced: true,
  state: {
    word_views: {
      loading: true,
      data: null
    },
    quiz_results: {
      loading: true,
      data: null
    }
  },
  getters: {
    computeQuizResultData: state => (data, cards) => {
      return _computeQuizResultData(data, cards);
    },
    computeWordviewData: state => (data, cards) => {
      return _computeWordviewData(data, cards);
    }
  },
  actions: {
    async fetchQuizStats({ commit }, { box }) {
      const entity = `quiz_results`;
      const url = `statistics/box/${box.id}/quiz/`;

      return new Promise((resolve, reject) => {
        commit(`SET_LOADING_STATUS`, { entity, status: true });
        axios
          .get(url)
          .then(({ data }) => {
            commit("SET_QUIZRESULT_DATA", {
              data: data.results,
              cards: box.cards
            });
            resolve(data);
          })
          .catch(error => {
            commit("SET_QUIZRESULT_DATA", { data: {}, cards: box.cards });
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING_STATUS", { entity, status: false });
          });
      });
    },
    async fetchWordViewStats({ commit }, { box }) {
      const entity = `word_views`;
      const url = `/statistics/box/${box.id}/wordviews/`;

      return new Promise((resolve, reject) => {
        commit(`SET_LOADING_STATUS`, { entity, status: true });
        axios
          .get(url)
          .then(({ data }) => {
            commit("SET_WORDVIEW_DATA", { data, cards: box.cards });
            resolve(data);
          })
          .catch(error => {
            commit("SET_WORDVIEW_DATA", { data: {}, cards: box.cards });
            reject(error);
          })
          .finally(() => {
            commit("SET_LOADING_STATUS", { entity, status: false });
          });
      });
    }
  },
  mutations: {
    SET_QUIZRESULT_DATA(state, { data, cards }) {
      state.quiz_results.data = _computeQuizResultData(data, cards);
    },
    SET_WORDVIEW_DATA(state, { data, cards }) {
      state.word_views.data = _computeWordviewData(data, cards);
    },
    SET_LOADING_STATUS(state, { entity, status }) {
      if (status) {
        state[entity].data = {};
      }
      state[entity].loading = status;
    }
  }
};
